import React, { useEffect, useRef, useState } from 'react';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

const SessionTimeout = () => {
  const navigate = useNavigate();
  const [timeout, setTimeoutValue] = useState(null);
  const lastActivityRef = useRef(Date.now());
  const debounceTimeout = useRef(null);
    const logoutOnce = useRef(false);
  
  // 🕓 Get session timeout from localStorage
  useEffect(() => {
    const storedTimeout = localStorage.getItem('session_timeout');
    if (storedTimeout) {
      const timeoutMs = parseInt(storedTimeout, 10) * 60 * 1000;
      setTimeoutValue(timeoutMs);
    }
  }, []);

const handleLogout = () => {
  if (logoutOnce.current) return;
  logoutOnce.current = true;

  const companyCode = Cookies.get("CM_CompanyCode");
  const redirectPath = companyCode ? `/${companyCode}` : "/";

  Cookies.remove("UserName", { path: "/" });
  // Cookies.remove("CM_CompanyCode", { path: "/" });

  localStorage.removeItem("session_timeout");
  localStorage.removeItem("user_id");
  sessionStorage.clear();

  navigate(redirectPath, { replace: true });
   Cookies.remove("CM_CompanyCode", { path: "/" });

  window.location.reload();
};

  
  // ⏳ Refresh cookie if active
  const refreshCookie = () => {
    const sessionTimeout = localStorage.getItem('session_timeout');
    const userName = Cookies.get('UserName');

    if (sessionTimeout && userName) {
      const sessionTimeoutInMinutes = parseInt(sessionTimeout, 10);
      const expiryDate = new Date(Date.now() + sessionTimeoutInMinutes * 60 * 1000);

      Cookies.set('UserName', userName, {
        path: '/',
        expires: expiryDate,
      });

      // console.log(`Cookie extended to: ${expiryDate.toUTCString()}`);
    }
  };

  // 📡 Activity handler
  const handleActivity = () => {
    const now = Date.now();
    const timeSinceLast = now - lastActivityRef.current;

    if (timeSinceLast > 1000) {
      lastActivityRef.current = now;
      refreshCookie();
    }
  };

  // 🧠 Listen for user activity
  useEffect(() => {
    const events = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart'];

    events.forEach((event) => {
      window.addEventListener(event, handleActivity);
    });

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, handleActivity);
      });
    };
  }, []);

  // 🕵️ Periodic check for cookie existence
  useEffect(() => {
    const checkInterval = setInterval(() => {
      const userCookie = Cookies.get('UserName');
      if (!userCookie) {
        console.warn('Session expired. Logging out...');
        handleLogout();
      }
    }, 5000);

    return () => clearInterval(checkInterval);
  }, []);

  return null;
};

export default SessionTimeout;

